export const BLUE = '#114338';
export const BLUE_DARKER = '#0B2F27';
export const BLUE_LIGHTER = '#2C6557';
export const IVORY = '#E9E2D9';
export const BRIGHT_GOLD = '#FBB03C';
